module.exports = __webpack_public_path__ + "img/logo.74e11741.svg";